import TextareaAutosize from "react-textarea-autosize";
import { CSSProperties, styled } from "styled-components";

import { BaseButton } from "../Button/styled";
import type { FeedbackRating } from "./index";

export const Container = styled.div<{
  $alignItems?: CSSProperties["alignItems"];
}>(({ $alignItems }) => {
  return {
    display: "flex",
    alignItems: $alignItems || "flex-start",
  };
});

interface ButtonProps {
  $rating?: FeedbackRating;
  $selected: boolean;
}

export const RateButton = styled(BaseButton)<ButtonProps>(({
  theme,
  $rating,
  $selected,
}) => {
  return {
    background: $selected
      ? $rating === "positive"
        ? theme.colors.green
        : theme.colors.warn
      : "transparent",
    marginRight: theme.space[2],
    borderRadius: theme.radii.round,
    padding: theme.space[1],
    transform: $rating === "negative" ? "rotate(180deg)" : undefined,

    "&:hover": {
      //backgroundColor: theme.colors.grayLight,
    },
  };
});

export const MessageContainer = styled.div(() => {
  return {
    position: "relative",
    flexGrow: 1,
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
  };
});

export const Input = styled(TextareaAutosize)<{ $hasUnsavedChanges: boolean }>(
  ({ theme, $hasUnsavedChanges }) => {
    return {
      width: "100%",
      fontSize: theme.fontSizes["2"],
      border: `1px solid ${
        $hasUnsavedChanges ? theme.colors.warn : "transparent"
      }`,
      borderRadius: theme.radii[1],
      padding: `${theme.space[2]} 32px ${theme.space[2]} ${theme.space[3]}`,
      color: theme.colors.grayDarker,
      boxSizing: "border-box",
      transition: "border-color 250ms",
      resize: "none",
      fontFamily: theme.fonts.default,
      fontStyle: "italic",

      "&:focus": {
        border: `1px solid ${theme.colors.grayMed}`,
        outline: "none",
        boxShadow: `0 1px 12px ${theme.shadows[2]}`,
      },

      "&::placeholder": {
        color: theme.colors.grayDark,
      },
    };
  },
);

export const SaveButton = styled(BaseButton)(({ theme }) => {
  return {
    background: "none",
    position: "absolute",
    right: theme.space[1],
    bottom: "50%",
    backgroundColor: "transparent",
    borderRadius: theme.radii.round,
    padding: theme.space[1],
    transform: "translateY(50%)",
    color: theme.colors.white,
    fontSize: theme.fontSizes[1],
    display: "none",

    // Show the button when the input sibling is focused
    [`${Input}:focus + &`]: {
      display: "flex",
    },
  };
});

/** Feedback text to display in "view-only" mode */
export const FeedbackText = styled.div(({ theme }) => {
  return {
    fontSize: theme.fontSizes[1],
    color: theme.colors.grayDark,
    fontStyle: "italic",
    marginLeft: theme.space[2],
  };
});

export const ResolvedContainer = styled.div(({ theme }) => {
  return {
    display: "flex",
    marginTop: theme.space[2],
    marginLeft: theme.space[2],
    alignItems: "center",
  };
});

export const MarkAsResolvedButton = styled(BaseButton)(({ theme }) => {
  return {
    background: "none",
    color: theme.colors.green,
    fontSize: theme.fontSizes[1],
    display: "flex",
    alignItems: "center",
    marginTop: theme.space[2],
    marginLeft: theme.space[2],
    border: "1px solid transparent",
    padding: `${theme.space[1]} ${theme.space[2]}`,
    height: "fit-content",
    width: "fit-content",
    borderRadius: theme.radii[1],

    "&:hover": {
      // borderColor: theme.colors.green,
      backgroundColor: theme.colors.greenLight,
    },
  };
});

/** TOMIS Users might accidentally mark as resolved, this is an undo button */
export const MarkAsUnresolvedButton = styled(MarkAsResolvedButton)(({
  theme,
}) => {
  return {
    color: theme.colors.warn,
    marginLeft: theme.space[4],
    marginTop: 0,

    "&:hover": {
      //borderColor: theme.colors.warn,
      backgroundColor: theme.colors.warnLight,
    },
  };
});
